import { Dialog, IDialog, SELECTORS as DIALOG_SELECTORS } from "../Dialog";

export interface IReveal extends IDialog {
    content: string;
}

const SELECTORS = {
    BTN_CLOSE: ":scope button[data-close]",
    TITLE: ":scope [data-title]"
};

export class Reveal extends Dialog implements IReveal {
    protected modal = true;
    protected templateId = "dialog-reveal";

    private btnClose: HTMLButtonElement;

    constructor(contentId: string, title: string) {
        super();
        this.content = contentId;
        this.title = title;
        this.btnClose = this.dialog.querySelector<HTMLButtonElement>(SELECTORS.BTN_CLOSE);
    }

    public render() {
        this.preventScroll();
        this.btnClose.addEventListener(
            "pointerup",
            () => {
                this.close();
            },
            this.eventOpts
        );
        return super.render();
    }

    set content(v: string) {
        const template = document.getElementById(v) as HTMLTemplateElement;
        const content = template.content.cloneNode(true) as HTMLDivElement;
        this.dialog.querySelector<HTMLDivElement>(DIALOG_SELECTORS.CONTENT).appendChild(content);
    }

    set title(v: string) {
        this.dialog.querySelector<HTMLSpanElement>(SELECTORS.TITLE).innerText = v;
    }
}
